import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/sessions`;

export const sessionsLinks = {
  root: () => base,
  events: () => `${base}/events`,
  eventsHistory: () => `${base}/events/history`,
  oneToOneHistory: () => `${base}/oneToOne/history`,
  scheduleOneToOne: () => `${base}/oneToOne`,
  scheduleRequest: (sessionId: number | ':sessionId') => `${base}/oneToOne/${sessionId}`,
  scheduleConfirmation: (
    sessionId: number | ':sessionId',
    { type = 'one_on_one' }: { type?: string } = {},
  ) => `${base}/${sessionId}/confirmation/${type}`,
  sessionDetails: (sessionId: number | ':sessionId') => `${base}/${sessionId}`,
  cancelSession: (sessionId: number | ':sessionId') => `${base}/${sessionId}/cancel`,
  rescheduleSession: (sessionId: number | ':sessionId') => `${base}/${sessionId}/reschedule`,
  sessionFeedback: (sessionId: number | ':sessionId') => `${base}/${sessionId}/feedback`,
  guestRegistration: (sessionId: number | ':sessionId') => `${base}/${sessionId}/guestRegistration`,
  confirmRegistration: () => `${base}/confirmRegistration`,
  sessionPublicFeedback: (guestToken: string) => `${base}/sessionFeedback/${guestToken}`,
  rescheduleWizard: (sessionId: number | ':sessionId') => `${base}/reschedule/${sessionId}/wizard`,
  downloadCertificate: (attendanceId: number | ':attendanceId') =>
    `${base}/${attendanceId}/certificate`,
  downloadPublicCertificate: (guestToken: string | ':guestToken') =>
    `${base}/certificate/${guestToken}`,
};
